export default "__VITE_PUBLIC_ASSET__aad52cd5__"